<template>
    <b-modal
        id="portfolio-edit-add-assignment-modal"
        v-model="modal"
        :title="$t('portfolio.add_exercise')"
        :ok-disabled="name === null && choice === 1"
        :ok-title="choice == null ? $t('common.close') : $t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-only="choice === null"
        @ok="onOk"
        ok-variant="primary"
        modal-class="apprentice-default-modal portfolio-edit-add-assignment-modal"
        size="xl">
        <b-alert
            v-if="hasError"
            variant="danger"
            show>
            {{ errorMessage }}
        </b-alert>

        <div
            class="assignment-choices"
            v-if="choice === null">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-4 new-assignment">
                    <div
                        class="add-new-assignment apprentice-simple-card"
                        @click="createNew()">
                        <div class="new-assignment-icon icon">
                            <i class="btn btn-primary-icon-only btn-add-layer"></i>
                        </div>
                        <div class="new-assignment-content content">
                            <h5 class="title">{{ $t('portfolio.new_assignment') }}</h5>
                            <div class="description">
                                {{
                                    $t('portfolio.start_with_an_empty_exercise_as_a_basis_for_creating_a_new_exercise')
                                }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6 col-lg-4 existing-assignment">
                    <div
                        class="new-existing-assignment apprentice-simple-card"
                        @click="copyExisting()">
                        <div class="new-existing-assignment-icon icon">
                            <i class="btn btn-primary-icon-only btn-books"></i>
                        </div>
                        <div class="new-assignment-content content">
                            <h5 class="title">{{ $t('portfolio.own_exercises') }}</h5>
                            <div class="description">
                                {{
                                    $t('lesson_module.copy_assignment_within_organization', {
                                        organization: $authUser.userable.name,
                                    })
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="assignment-new-name"
            v-if="choice === 1">
            <b-form-group
                class="assignment-title-group"
                :label="$t('portfolio.title_exercise')"
                label-for="portfolio-edit-title-input">
                <b-form-input
                    id="portfolio-edit-title-input"
                    v-model="name"
                    :placeholder="$t('portfolio.type_the_name_of_the_assignment_here')">
                </b-form-input>
            </b-form-group>
        </div>
        <div
            class="assignment-copy-existing"
            v-if="choice === 2">
            <div
                class="group"
                v-if="lessonModules.length">
                <b-form-group
                    :label="$t('lesson_module.select_lesson_module')"
                    label-for="portfolio-lesson-module-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="portfolio-lesson-module-select"
                        v-model="selectedLessonModuleId"
                        v-if="lessonModules.length"
                        :options="lessonModules"
                        value-field="id"
                        text-field="name">
                    </b-form-select>
                </b-form-group>
            </div>

            <div
                class="category"
                v-if="selectedLessonModule">
                <b-form-group
                    :label="$t('portfolio.select_category')"
                    label-for="portfolio-category-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="portfolio-category-select"
                        v-model="selectedCategoryId"
                        :options="selectedLessonModule.portfolio.categories"
                        value-field="id"
                        text-field="name">
                    </b-form-select>
                </b-form-group>
            </div>

            <div
                class="assignment"
                v-if="selectedCategory">
                <b-form-group
                    :label="$t('portfolio.select_exercise')"
                    label-for="portfolio-assignment-select">
                    <b-form-select
                        class="apprentice-primary-select"
                        id="portfolio-assignment-select"
                        v-model="selectedAssignmentId"
                        :options="selectedCategory.assignments"
                        value-field="id"
                        text-field="name">
                    </b-form-select>
                </b-form-group>
            </div>

            <div
                class="loading"
                v-if="!lessonModules.length">
                <i class="fa fa-spinner fa-spin"></i>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-lesson-module-portfolio-add-new-assignment-modal-component',
    props: ['portfolioIn'],
    data() {
        return {
            name: null,
            portfolio: this.portfolioIn,
            hasError: false,
            choice: null,
            errorMessage: '',
            modal: false,
            lessonModules: [],
            selectedLessonModuleId: null,
            selectedCategoryId: null,
            selectedAssignmentId: null,
            categoryId: null,
        };
    },
    computed: {
        selectedLessonModule() {
            if (this.selectedLessonModuleId) {
                let lessonModule = this.lessonModules.find((lm) => lm.id === this.selectedLessonModuleId);
                if (lessonModule.portfolio.categories.length) {
                    this.errorMessage = this.$t('lesson_module.no_categories_found');
                } else {
                    this.errorMessage = null;
                }
                return lessonModule;
            }

            return null;
        },

        selectedCategory() {
            if (this.selectedCategoryId) {
                let category = this.selectedLessonModule?.portfolio.categories.find(
                    (lm) => lm.id === this.selectedCategoryId,
                );
                if (!category.assignments.length) {
                    this.errorMessage = this.$t('lesson_module.no_assignments_found');
                } else {
                    this.errorMessage = null;
                }
                return category;
            }

            return null;
        },
    },

    methods: {
        onOk() {
            if (this.choice === 1) {
                this.createAssignment();
            } else if (this.choice === 2) {
                this.copyAssignment();
            }
        },

        createAssignment() {
            this.hasError = false;

            if (this.name === null || this.name === '') {
                this.hasError = true;
                this.errorMessage = this.$t('lesson_module.exercise_name_cannot_be_empty');
            }

            if (this.name && this.name.length > 192) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.name_191_max');
            }

            if (this.hasError) {
                bvModalEvt.preventDefault();
            }

            let data = {
                name: this.name,
            };

            this.alert.saving(
                this.$t('portfolio.add_exercise'),
                this.$t('portfolio.exercise_will_be_added_please_wait_a_moment'),
            );

            this.axios.post(this.routes.newAssignmentStore(this.portfolioIn.id, this.categoryId), data).then(
                (response) => {
                    this.$emit('category-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        copyAssignment() {
            this.alert.saving('Opdracht toevoegen', 'De opdracht wordt toegevoegd, één moment geduld a.u.b.');

            let data = {
                assignment_id: this.selectedAssignmentId,
                category_id: this.categoryId,
            };

            this.axios.post(this.routes.newCopyAssignment(this.portfolioIn.id, this.categoryId), data).then(
                (response) => {
                    this.$emit('category-updated', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        show(categoryId) {
            this.choice = null;
            this.name = null;
            this.selectedAssignmentId = null;
            this.hasError = false;
            this.selectedLessonModuleId = null;
            this.selectedCategoryId = null;
            this.selectedAssignmentId = null;
            this.categoryId = categoryId;
            this.modal = true;
        },
        createNew() {
            this.choice = 1;
        },
        copyExisting() {
            this.choice = 2;

            this.axios.get(this.routes.getLessonModules(this.$authUser.userable_id)).then(
                (response) => {
                    this.lessonModules = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.new-assignment,
.existing-assignment,
.shared-assignment {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.add-new-assignment,
.new-existing-assignment,
.new-shared-assignment {
    height: 100%;
    position: relative;
    background-color: $secondary-background-color;

    .icon {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        i {
            font-size: 6rem;
        }
    }

    .content {
        .title {
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }

        .description {
            color: $text-muted-color;
        }
    }

    &:hover {
        cursor: pointer;
        box-shadow: 1px 0px 4px $border-color;

        .icon {
            i {
                color: var(--primaryLightest);
            }
        }
    }
}

.assignment-new-name {
    display: flex;
    justify-content: space-between;
    row-gap: $grid-gutter-width;
    align-items: flex-start;

    input {
        border: 1px solid $border-color;
    }

    .assignment-title-group {
        flex-basis: calc(67% - 15px);
    }

    .available-tags-group {
        flex-basis: calc(33% - 15px);
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .new-assignment,
    .existing-assignment,
    .shared-assignment {
        margin-bottom: 0;
    }
}
</style>
